export default __webpack_public_path__ + "static/media/ped_download.aa374643.svg";